import {
  UserAgreement,
  PrivateAgreement,
  ThirdPartyAgreement,
} from '@/components/agreement'
import React from 'react'
import Card from '../common/Card'
import { Title } from '@/views/wallet'
import { List } from 'antd'
export default function Agreement() {
  return (
    <div>
      <Title>服务协议</Title>
      <Card style={{ justifyContent: 'flex-start' }}>
        <List
          dataSource={[
            { title: '用户服务协议', content: <UserAgreement /> },
            { title: '隐私政策', content: <PrivateAgreement /> },
            { title: '第三方服务协议', content: <ThirdPartyAgreement /> },
          ]}
          renderItem={(item) => (
            <List.Item>
              <div>{item.content}</div>
            </List.Item>
          )}
        />
      </Card>
    </div>
  )
}
